/**
 * @file コンポーネント：検索機能付きフォームプルダウン スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledPulldown = styled.div`
    display: inline-block;
    position: relative;
    border-radius: 4px;
    cursor: default;

    &::after {
        position: absolute;
        top: 0;
        right: 4px;
        bottom: 0;
        z-index: 1;
        width: 24px;
        height: 24px;
        margin: auto 0;
        font-weight: bold;
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        content: "\f0d7";
    }

    &[data-on-color="gray"] {
        background-color: #ffffff;

        &::after {
            color: #7e7e7e;
        }
    }

    &[data-on-color="main"] {
        &::after {
            color: #808385;
        }
    }

    &[data-on-color="white"] {
        &::after {
            color: #949494;
        }
    }

    &.is-wide {
        width: 100%;
    }
`;

export const StyledPulldownModal = styled.div``;

export const StyledPulldownSearchlist = styled.ul`
    margin-top: 24px;
    height: 240px;
    overflow: hidden auto;
`;

export const StyledPulldownSearchlistItem = styled.li`
    padding: 0 10px;
    overflow: hidden;
    color: #25292d;
    font-size: 16px;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: default;
    user-select: none;

    &.is-active {
        background-color: #1e90ff;
        color: #ffffff;
    }
`;

export const StyledPulldownSelect = styled.select`
    display: none;
`;

export const StyledPulldownSelected = styled.div`
    position: relative;
    z-index: 2;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    font-size: 16px;
    line-height: 24px;

    &[data-on-color="gray"] {
        padding: 8px 26px 8px 10px;
        border-color: #7e7e7e;
        color: #25292d;
    }

    &[data-on-color="main"] {
        padding: 4px 28px 4px 12px;
        border-color: #808385;
        color: #e3e3e4;
    }

    &[data-on-color="white"] {
        padding: 8px 26px 8px 10px;
        border-color: #949494;
        color: #25292d;
    }
`;

export const StyledPulldownSelectOption = styled.option``;
